import { render, staticRenderFns } from "./propertyNoticeDetail.vue?vue&type=template&id=cae04e32&scoped=true"
import script from "./propertyNoticeDetail.vue?vue&type=script&lang=js"
export * from "./propertyNoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./propertyNoticeDetail.vue?vue&type=style&index=0&id=cae04e32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae04e32",
  null
  
)

export default component.exports